
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M21.94 11.23C21.57 8.75999 19.32 6.99999 16.82 6.99999H13.95C13.43 6.99999 13 7.42999 13 7.94999C13 8.46999 13.43 8.89999 13.95 8.89999H16.85C18.45 8.89999 19.8899 10.04 20.07 11.63C20.24 13.06 19.43 14.32 18.2199 14.85L19.62 16.25C21.25 15.23 22.26 13.34 21.94 11.23ZM4.11995 3.55999C3.72995 3.16999 3.09995 3.16999 2.70995 3.55999C2.31995 3.94999 2.31995 4.57999 2.70995 4.96999L5.10995 7.36999C3.16995 8.16999 1.83995 10.14 2.01995 12.41C2.22995 15.05 4.58995 17 7.22995 17H10.05C10.57 17 11 16.57 11 16.05C11 15.53 10.57 15.1 10.05 15.1H7.15995C5.52995 15.1 4.05995 13.91 3.90995 12.28C3.75995 10.56 5.01995 9.10999 6.65995 8.92999L8.75995 11.03C8.32995 11.12 7.99995 11.49 7.99995 11.95V12.05C7.99995 12.57 8.42995 13 8.94995 13H10.7299L13 15.27V17H14.7299L18.03 20.3C18.42 20.69 19.05 20.69 19.44 20.3C19.83 19.91 19.83 19.28 19.44 18.89L4.11995 3.55999ZM16 11.95C16 11.43 15.57 11 15.05 11H14.39L15.88 12.49C15.95 12.36 16 12.21 16 12.05V11.95Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-link-off`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconLinkOff

    ```js
    <b-new-b-icon-link-off />
    ```
</docs>


